<template>
    <div class="careers-career">
      <div class="careers-career-content">
          <p class="indent">Good intra-corporate relations and effective human resource management are an essential part of Alcomet’s business strategy. The company’s main goals are to increase the levels of employee motivation and satisfaction and to offer excellent working conditions, providing a healthy and safe working environment. The company respects the human rights of each employee; recognizes individual differences and provides equal career and development opportunities, regardless of nationality, beliefs, religion, ethnicity and age. Alcomet offers considerable training and career opportunities for young professionals through a variety of student training programmes and individual scholarships.</p>
      </div>
      <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.careers-career-content {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.careers-career-content > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto 0;
  text-align: justify;
  width: 60%;
}
@media screen and (max-width: 1000px) {
  .careers-career-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/careers/Career.vue